// client/src/lib/screenNames.ts
// Map a route pathname -> a clean, ID-stripped screen name, used for the GA4
// page_title and the Clarity `screen` tag. Keeps cardinality low so
// /quotations/123 and /quotations/456 both report as "Quotation Detail".
// Pure + testable. Order matters: more specific patterns must come first.

const RULES: Array<[RegExp, string]> = [
  [/^\/login$/, 'Login'],
  [/^\/forgot-password$/, 'Forgot Password'],
  [/^\/reset-password$/, 'Reset Password'],
  [/^\/respond\//, 'Client Price List Response'],
  [/^\/app$/, 'Dashboard'],
  [/^\/rfq$/, 'RFQ Inbox'],
  [/^\/quotations\/[^/]+$/, 'Quotation Detail'],
  [/^\/quotations$/, 'Quotations'],
  [/^\/confirmed-orders\/[^/]+\/invoice$/, 'Client Invoice Detail'],
  [/^\/confirmed-orders\/[^/]+$/, 'Confirmed Order Detail'],
  [/^\/confirmed-orders$/, 'Confirmed Orders'],
  [/^\/client-invoices\/[^/]+$/, 'Client Invoice Detail'],
  [/^\/client-invoices$/, 'Client Invoices'],
  [/^\/credit-notes\/new$/, 'Credit Note New'],
  [/^\/credit-notes\/[^/]+$/, 'Credit Note Detail'],
  [/^\/credit-notes$/, 'Credit Notes'],
  [/^\/vendor-purchase-orders\/[^/]+$/, 'Vendor PO Detail'],
  [/^\/vendor-purchase-orders$/, 'Vendor POs'],
  [/^\/vendor-invoices$/, 'Vendor Invoices'],
  [/^\/vendors$/, 'Vendors'],
  [/^\/clients$/, 'Clients'],
  [/^\/master-catalogue$/, 'Master Catalogue'],
  [/^\/price-list$/, 'Price List'],
  [/^\/client-price-lists\/[^/]+$/, 'Client Price List Detail'],
  [/^\/client-price-lists$/, 'Client Price Lists'],
  [/^\/inventory$/, 'Inventory'],
  [/^\/accounts\/payments\//, 'Payment Voucher'],
  [/^\/accounts\/vouchers$/, 'Payment Vouchers'],
  [/^\/accounts\/suppliers\//, 'Supplier Account'],
  [/^\/accounts\/[^/]+$/, 'Account Detail'],
  [/^\/accounts$/, 'Accounts'],
  [/^\/users$/, 'Users'],
  [/^\/templates$/, 'Templates'],
  [/^\/reports$/, 'Reports'],
  [/^\/settings$/, 'Settings'],
  [/^\/currency-conversion$/, 'Currency Conversion'],
];

export function screenNameForPath(pathname: string): string {
  const p = (pathname || '/').replace(/\/+$/, '') || '/';
  for (const [re, name] of RULES) {
    if (re.test(p)) return name;
  }
  return 'Unknown';
}
